import React from 'react';
import './emptyList.scss';

export default props => (
  <div className="error-page">
    <i className="fa fa-exclamation-triangle fa-4" aria-hidden="true"></i>
    <span>Nenhum item encontrado</span>
  </div>
);
